export const userSelector = (state) => ({
  user: state.user
});
